
  import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import pagelist from '@/components/pagelistcomponent';
  import AbpBase from '@/lib/abpbase';
  import * as proxy from '@/lib/service-proxies/service-proxies';
  import AppConsts from '@/lib/appconst';
  import PagedFilterAndSortedRequest from '@/store/entities/page-request';
  @Component
  export default class systemsetting extends pagelist {
    get autoTradeproxy() {
      return new proxy.MerchantClientServiceProxy();
    }
    model: proxy.MerchantInfoDto = new proxy.MerchantInfoDto();
    platfroms = [];
    googlecode=''
    getpage() {
      this.autoTradeproxy.getMyInfo().then(x => {
        this.model = x;
      });
    }
    async created() {
      this.getpage();
    }
    save() {
      
    }
    ShowAppkey() {
   
    let req = new proxy.ShowAppkeyInputDto();
    req.googleCode=this.googlecode
    this.autoTradeproxy.showAppkey(req).then(x => {
      this.$Modal.info({
        title: '查看商户key',
        content: x,
        width:800
      });
    })
  }
  }
  